// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Avoid wrapping with fontawesome icons */
.fa {
  display: inline;
}

/* Do not underline links */
a:hover {
  text-decoration: none;
}

.navbar-top {
  background-color: #4389d4;
}

.navbar-top .navbar-brand {
  color: white;
}

.navbar-top .navbar-user > li > a {
  color: black;
}

.navbar-side {
  background-color: #2a70b9;
  bottom: 0px;
  left: 0px;
  position: absolute;
  top: 67px;
  width: 250px;
  z-index: 8;
  overflow: hidden;
  transition: all 0.3s ease-in-out;
}

.navbar-side.collapsed {
  width: 70px;
}

.navbar-side.collapsed .fa {
  font-size: 22px;
}

.navbar-side.collapsed .nav-label {
  display: none;
}

.btn-expand-collapse {
  color: white;
  font-size: 22px;
  text-align: center;
  margin-left: 0px;
  margin-right: 20px;
}

.btn-expand-collapse:hover {
  color: #215790;
}

.navbar-side-menu,
.navbar-side-menu li {
  margin: 0;
  padding: 0;
  list-style: none;
  overflow: hidden;
}

.navbar-side-menu li a {
  background-color: #2a70b9;
  display: block;
  padding: 15px 22px;
  text-align: left;
  border-bottom: solid 1px white;
  color: white;
}

.navbar-side-menu li a:hover {
  background-color: #245e9c;
  text-decoration: none;
  color: white;
}

.navbar-side-menu li a .fa {
  margin-right: 8px;
}

.main-content {
  margin-left: 250px;
  padding: 20px;
}

.collapsed + .main-content {
  margin-left: 70px;
}

span.nav-label {
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/app/main/main.component.scss"],"names":[],"mappings":"AAAA,0CAAA;AACA;EACE,eAAA;AACF;;AAEA,2BAAA;AACA;EACE,qBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,yBAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EAGA,gCAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,YAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;;EAEE,SAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,8BAAA;EACA,YAAA;AACF;;AAEA;EACE,yBAAA;EACA,qBAAA;EACA,YAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,mBAAA;AACF","sourcesContent":["/* Avoid wrapping with fontawesome icons */\n.fa {\n  display: inline;\n}\n\n/* Do not underline links */\na:hover {\n  text-decoration: none;\n}\n\n.navbar-top {\n  background-color: lighten(#2f7cce, 5%);\n}\n\n.navbar-top .navbar-brand {\n  color: white;\n}\n\n.navbar-top .navbar-user > li > a {\n  color: black;\n}\n\n.navbar-side {\n  background-color: darken(#2f7cce, 5%);\n  bottom: 0px;\n  left: 0px;\n  position: absolute;\n  top: 67px;\n  width: 250px;\n  z-index: 8;\n  overflow: hidden;\n  -webkit-transition: all 0.3s ease-in-out;\n  -moz-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n}\n\n.navbar-side.collapsed {\n  width: 70px;\n}\n\n.navbar-side.collapsed .fa {\n  font-size: 22px;\n}\n\n.navbar-side.collapsed .nav-label {\n  display: none;\n}\n\n.btn-expand-collapse {\n  color: white;\n  font-size: 22px;\n  text-align: center;\n  margin-left: 0px;\n  margin-right: 20px;\n}\n\n.btn-expand-collapse:hover {\n  color: darken(#2f7cce, 15%);\n}\n\n.navbar-side-menu,\n.navbar-side-menu li {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  overflow: hidden;\n}\n\n.navbar-side-menu li a {\n  background-color: darken(#2f7cce, 5%);\n  display: block;\n  padding: 15px 22px;\n  text-align: left;\n  border-bottom: solid 1px white;\n  color: white;\n}\n\n.navbar-side-menu li a:hover {\n  background-color: darken(#2f7cce, 12%);\n  text-decoration: none;\n  color: white;\n}\n\n.navbar-side-menu li a .fa {\n  margin-right: 8px;\n}\n\n.main-content {\n  margin-left: 250px;\n  padding: 20px;\n}\n\n.collapsed + .main-content {\n  margin-left: 70px;\n}\n\nspan.nav-label {\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
